import {Box, BoxProps, Center} from '@chakra-ui/react';
import {FC} from 'react';

interface Props extends BoxProps {
  innerbox?: BoxProps;
  isMetro?: boolean;
}

export const HeaderWrapper: FC<Props> = ({children, innerbox, isMetro, ...boxProps}) => {
  return (
    <Box w="100%" bg="white" {...boxProps}>
      <Center px={['15px', '30px']} h={['50px', '80px']} maxW={isMetro ? '1800px' : '1440px'} mx="auto" {...innerbox}>
        {children}
      </Center>
    </Box>
  );
};
